// extracted by mini-css-extract-plugin
module.exports = {"container":"i_w"};